import { ApiResponse, getFromServer } from "server";

export interface StudentDashboardStatsOutput {
  totalCount: number;
  statusCount: {
    in_standby: number;
    in_processing: number;
    resolved: number;
    rejected: number;
  };
  subjectDistribution: {
    [key: string]: number;
  };
}

// Route : GET /problems/mine/stats
export async function getStudentDashboardStats(): Promise<
  ApiResponse<StudentDashboardStatsOutput>
> {
  return await getFromServer<StudentDashboardStatsOutput>(
    "/problems/mine/stats",
  );
}
